import { render } from "./ContentLoader.vue?vue&type=template&id=519436f8&scoped=true&ts=true"
import script from "./ContentLoader.vue?vue&type=script&lang=ts"
export * from "./ContentLoader.vue?vue&type=script&lang=ts"

import "./ContentLoader.vue?vue&type=style&index=0&id=519436f8&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web-staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-519436f8"]])

export default __exports__